import type { ReactElement } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  TodayIcon,
  FoodIcon,
  BodyIcon,
  MedsIcon,
  PlanIcon,
  TrainIcon,
} from '@/components/icons';

interface Tab {
  to: string;
  labelKey: string;
  Icon: (props: { active?: boolean }) => ReactElement;
  match: 'exact' | 'prefix';
}

const TABS: Tab[] = [
  { to: '/', labelKey: 'nav.today', Icon: TodayIcon, match: 'exact' },
  { to: '/food', labelKey: 'nav.food', Icon: FoodIcon, match: 'prefix' },
  { to: '/body', labelKey: 'nav.body', Icon: BodyIcon, match: 'prefix' },
  { to: '/meds', labelKey: 'nav.meds', Icon: MedsIcon, match: 'prefix' },
  { to: '/train', labelKey: 'nav.train', Icon: TrainIcon, match: 'prefix' },
  { to: '/plan', labelKey: 'nav.plan', Icon: PlanIcon, match: 'prefix' },
];

export function TabBar() {
  const { pathname } = useLocation();
  const { t } = useTranslation();

  const isActive = (tab: Tab) => {
    if (tab.match === 'exact') return pathname === '/' || pathname === '';
    const path = pathname.replace(/\/+$/, '');
    return path === tab.to || path.startsWith(`${tab.to}/`);
  };

  return (
    <nav className="tabbar">
      {TABS.map((tab) => {
        const active = isActive(tab);
        return (
          <NavLink
            key={tab.to}
            to={tab.to}
            end={tab.match === 'exact'}
            className={({ isActive: routerActive }) =>
              `tabbar-item${routerActive || active ? ' active' : ''}`
            }
          >
            <tab.Icon active={active} />
            <span>{t(tab.labelKey)}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}
